// extracted by mini-css-extract-plugin
export var img = "Instagram-module--img--6eo5p";
export var img0 = "Instagram-module--img-0--aZ1g1";
export var imgWrapper = "Instagram-module--imgWrapper--tiCxP";
export var inner = "Instagram-module--inner--gyYMB";
export var innerImgGrid = "Instagram-module--innerImgGrid--li65c";
export var innerImgWrapper = "Instagram-module--innerImgWrapper--CfnIN";
export var link = "Instagram-module--link--Kgb8A";
export var text = "Instagram-module--text--Ruonx";
export var wrapper = "Instagram-module--wrapper--sIyc5";